import Vue from 'vue'
import App from './App.vue'
import 'minireset.css'
import Axios from 'axios'

Vue.config.productionTip = false

var http = new Axios.create()

Vue.prototype.$http = http

window.app = new Vue({
  data() {
    return {
      ui: false
    }
  },
  methods: {
    kr() {
      return document.querySelector('#krpanoSWFObject')
    },
    showUI(flag) {
      if (flag !== undefined) {
        this.ui = flag
        return
      }
      this.ui = !this.ui
    },
    loadpage(url){
      this.$children[0].loadUrl(url)
    }
  },
  render: h => h(App),
}).$mount('#app')
